<template>
	<header id="header" class="header">
		<section class="headline">
		<div class="inner">
			<a
			class="logo"
			href="https://www.pixnet.net/"
			target="_blank"
			rel="noreferrer noopener"
			></a>
		</div>
		</section>
		<section class="kv">
			<div class="inner">
				<div class="bg">
					<img class="bg-image" :src="bannerImage" alt="龜甲萬集結頁 banner" />
				</div>
			</div>
		</section>
	</header>
</template>

<script>
import bannerImage from "@/assets/banner.jpg";

export default {
	name: "NavbarComponent",
	data() {
		return {
			bannerImage,
		};
	},
};
</script>
